var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.941 36 36 27.941 36 18C36 8.05899 27.9397 0 18 0C8.05899 0 0 8.05899 0 18C0 27.941 8.05899 36 18 36Z",
    fill: "url(#paint0_radial_3614_16562)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9988 28.4437C21.3797 28.4437 24.1192 23.7695 24.1192 18.0039C24.1192 12.237 21.3797 7.56278 18.0001 7.56278C14.6191 7.56278 11.8784 12.237 11.8784 18.0026C11.8784 23.7695 14.6191 28.4437 17.9988 28.4437Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52408 9.71861C4.70762 9.62605 2.51836 13.4274 2.51836 17.9974C2.51836 22.5701 4.70762 26.3701 6.52408 26.2762C8.3251 26.1837 9.35867 22.5701 9.35867 17.9974C9.35867 13.4274 8.3251 9.81245 6.52408 9.71861ZM29.4734 26.2775C31.2898 26.3701 33.4791 22.5701 33.4791 17.9987C33.4791 13.4274 31.2898 9.62605 29.4734 9.7199C27.6723 9.81245 26.6388 13.4274 26.6388 17.9987C26.6388 22.5701 27.6723 26.1837 29.4734 26.2775Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3614_16562",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18 12.9607) rotate(90) scale(23.0398 29.9147)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FF6427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB581E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360);
export default __webpack_public_path__ + "static/media/360.060389e14853830f82581859a48048c3.svg";
export { ForwardRef as ReactComponent };